import(/* webpackMode: "eager", webpackExports: ["Button"] */ "/app/front_end/node_modules/@headlessui/react/dist/components/button/button.js");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/app/front_end/node_modules/next-intl/dist/esm/shared/NextIntlClientProvider.js");
;
import(/* webpackMode: "eager" */ "/app/front_end/node_modules/next/dist/client/app-dir/link.js");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/app/front_end/src/app/(main)/(leaderboards)/contributions/components/contributions_table.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/app/front_end/src/components/refresh_button.tsx");
